import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

import { submitDealerPartner } from './dealer-partner.api';
import { DealerPartner } from './dealer-partner.type';

export const useSubmitDealerPartnerMutation = () => {
  return useMutation({
    mutationFn: (data: DealerPartner) => submitDealerPartner(data),
    onSuccess: () => {
      toast.success('Dealer partner submitted successfully');
    },
    onError: () => {
      toast.error('Failed to submit dealer partner');
    },
  });
};
